import { useEffect, useRef } from 'react';

export const useUpdateEffect = (callback: () => void, dependencies?: Array<unknown>) => {
  const initialUpdate = useRef(true);

  useEffect(() => {
    initialUpdate.current = true;
  }, []);

  useEffect(() => {
    if (initialUpdate.current) {
      initialUpdate.current = false;
      return;
    }
    return callback();
  }, dependencies);
};
